import { findPageDescriptorById } from './util.find-page-descriptor-by-id.js';

function recursivelyFindParentBreadcrumb(state, page) {
  if (!(page == null ? void 0 : page.parentId)) {
    return [];
  }
  const parentPage = findPageDescriptorById(state, page.parentId);
  if (!parentPage || parentPage.path === "/") {
    return [];
  }
  return [...recursivelyFindParentBreadcrumb(state, parentPage), parentPage];
}

export { recursivelyFindParentBreadcrumb };
//# sourceMappingURL=util.recursively-find-parent-breadcrumb.js.map
